import { render, staticRenderFns } from "./reasons-table.vue?vue&type=template&id=876ab7b0&scoped=true"
import script from "./reasons-table.vue?vue&type=script&lang=js"
export * from "./reasons-table.vue?vue&type=script&lang=js"
import style0 from "./reasons-table.vue?vue&type=style&index=0&id=876ab7b0&prod&lang=scss"
import style1 from "./reasons-table.vue?vue&type=style&index=1&id=876ab7b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876ab7b0",
  null
  
)

export default component.exports